import React from "react";
import _ from "lodash";
import ReactGA from "react-ga";

import { getCurrentPage } from "../helpers";

import MainNav from "./MainNav";

class Sidebar extends React.Component {
	toggleSidebar = (e) => {
		e.preventDefault();

		const newState = this.props.sidebar.status === "show" ? "hide" : "show";

		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: "Toggle Sidebar",
			label: newState,
		});

		this.props.setSidebar(newState);
	};

	scrollSidebarTo = (position) => {
		if (this.refs && this.refs.sidebar) {
			this.refs.sidebar.scrollTop = position;
		}
	};

	checkSidebarStatus = () => {
		const newStatus = getCurrentPage() === "explore-map" ? "hide" : "show";

		this.props.setSidebar(newStatus);
	};

	componentDidMount() {
		this.checkSidebarStatus();
	}

	componentDidUpdate(prevProps) {
		const newLocationURL = !_.isEqual(
			this.props.location.pathname,
			prevProps.location.pathname
		);

		if (newLocationURL) {
			this.checkSidebarStatus();
		}
	}

	render() {
		// Pass required props down to children
		const children = React.Children.map(this.props.children, (child) => {
			return React.cloneElement(child, {
				scrollSidebarTo: this.scrollSidebarTo,
				cleanupRoutePlanning: this.props.cleanupRoutePlanning,
				cleanupLeisureRides: this.props.cleanupLeisureRides,
			});
		});

		return (
			<main
				id="main"
				className={ `sidebar status-${ this.props.sidebar.status }` }
			>
				<MainNav { ...this.props } />

				<div ref="sidebar" className="sidebar-content-area">
					{ children }
				</div>

				<button className="map-link" onClick={ (e) => this.toggleSidebar(e) }>
					<span className="assistive-text">Toggle sidebar</span>
					<svg className="icon" aria-hidden="true">
						<use xlinkHref="#arrow_carrot-left" />
					</svg>
				</button>
			</main>
		);
	}
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js